import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { Fragment } from "react";

export const Modal = ({
  closeModal,
  isModalOpen,
  renderContent,
  isGallery = false,
  isBigAsFuck = false,
}: {
  renderContent: () => React.ReactNode;
  closeModal: () => void;
  isModalOpen: boolean;
  isGallery?: boolean;
  isBigAsFuck?: boolean;
}) => {
  return (
    <Transition show={isModalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={closeModal}>
        {/* Backdrop */}
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`fixed inset-0 ${
              isBigAsFuck || isGallery ? "bg-black bg-opacity-[0.99]" : "bg-gray-500 bg-opacity-75"
            } transition-opacity`}
            aria-hidden="true"
          />
        </TransitionChild>

        {/* Full screen scrollable container */}
        <div className="fixed inset-0 z-10 overflow-y-auto max-sm:max-h-[88vh]">
          {/* Container to center the panel */}
          <div className="flex justify-center p-8 sm:min-h-full sm:items-center sm:p-12">
            {/* Panel */}
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 sm:scale-95"
              enterTo="opacity-100 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 sm:scale-100"
              leaveTo="opacity-0 sm:scale-95"
            >
              <DialogPanel
                className={
                  isBigAsFuck
                    ? "relative h-screen w-screen p-8"
                    : isGallery
                      ? "text-text-color"
                      : "relative max-w-[450px] transform rounded-lg bg-background text-text-color shadow-xl transition-all sm:m-8 w-full"
                }
              >
                {renderContent()}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
